import calibService from "../../../services/calib.service";
import { SET_MESSAGE } from "../message/type";
import {
  CREATE_CALIB_FAIL,
  CREATE_CALIB_SUCCESS,
  LIST_CALIB_FAIL,
  LIST_CALIB_SUCCESS,
  ME_CALIB_SUCCESS,
  ME_CALIB_FAIL,
  ONE_CALIB_SUCCESS,
  ONE_CALIB_FAIL,
  LIST_CALIB_DESACTIVER_SUCCESS,
  LIST_CALIB_DESACTIVER_FAIL,
  DEACTIVATE_CALIB_SUCCESS,
  DEACTIVATE_CALIB_FAIL,
  CHANGER_ACCES_CALIB_SUCCESS,
  CHANGER_ACCES_CALIB_FAIL,
  UPDATE_CALIB_SUCCESS,
  UPDATE_CALIB_FAIL,
  RESET_STATUS_LIST,
} from "./type";

export const resetStatusList = () => {
  return {
    type: RESET_STATUS_LIST,
  };
};

export const getAllCALIBs = (page, size) => (dispatch) => {
  return calibService.allCalibs(page, size).then(
    (response) => {
      dispatch({
        type: LIST_CALIB_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: LIST_CALIB_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};
export const getCalibsByTenantId = (page, size) => (dispatch) => {
  return calibService.getCalibsByTenantId(page, size).then(
    (response) => {
      dispatch({
        type: LIST_CALIB_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: LIST_CALIB_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};
export const createCalibrage = (data) => (dispatch) => {
  return calibService.createCalibrage(data).then(
    (response) => {
      dispatch({
        type: CREATE_CALIB_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: CREATE_CALIB_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.response.data.status,
        },
      });

      return Promise.reject();
    }
  );
};

export const updateCalibrage = (data) => (dispatch) => {
  return calibService.updateCalibrage(data).then(
    (response) => {
      dispatch({
        type: UPDATE_CALIB_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: UPDATE_CALIB_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.response.data.status,
        },
      });

      return Promise.reject();
    }
  );
};

export const getMesCalibs = (page, size) => (dispatch) => {
  return calibService.meCalibs(page, size).then(
    (response) => {
      dispatch({
        type: ME_CALIB_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: ME_CALIB_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};

export const getMesCalibsWithFilter =
  (page, size, statusList) => (dispatch) => {
    return calibService.meCalibsWithFilter(page, size, statusList).then(
      (response) => {
        dispatch({
          type: ME_CALIB_SUCCESS,
          payload: response.data,
        });
        dispatch({
          type: SET_MESSAGE,
          payload: {
            message: response.message,
            status: response.status,
          },
        });

        return Promise.resolve();
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        dispatch({
          type: ME_CALIB_FAIL,
        });

        dispatch({
          type: SET_MESSAGE,
          payload: {
            message: message,
            status: error.status,
          },
        });

        return Promise.reject();
      }
    );
  };
export const getOneCalibrage = (calibIdId) => (dispatch) => {
  return calibService.oneCalibrage(calibIdId).then(
    (response) => {
      dispatch({
        type: ONE_CALIB_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: ONE_CALIB_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};
export const allCalibsWithFilter = (page, size, statusList) => (dispatch) => {
  return calibService.allCalibsWithFilter(page, size, statusList).then(
    (response) => {
      dispatch({
        type: LIST_CALIB_DESACTIVER_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: LIST_CALIB_DESACTIVER_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.status,
        },
      });

      return Promise.reject();
    }
  );
};

export const deactivateCalib = (evalId) => (dispatch) => {
  return calibService.deactivateCalib(evalId).then(
    (response) => {
      dispatch({
        type: DEACTIVATE_CALIB_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: DEACTIVATE_CALIB_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.response.data.status,
        },
      });

      return Promise.reject();
    }
  );
};
export const libererAcces = (calibId) => (dispatch) => {
  return calibService.LibererAcces(calibId).then(
    (response) => {
      dispatch({
        type: CHANGER_ACCES_CALIB_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: CHANGER_ACCES_CALIB_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.response.data.status,
        },
      });

      return Promise.reject();
    }
  );
};
export const prendreAcces = (calibId) => (dispatch) => {
  return calibService.PrendreAcces(calibId).then(
    (response) => {
      dispatch({
        type: CHANGER_ACCES_CALIB_SUCCESS,
        payload: response.data,
      });
      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: response.message,
          status: response.status,
        },
      });

      return Promise.resolve();
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: CHANGER_ACCES_CALIB_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: {
          message: message,
          status: error.response.data.status,
        },
      });

      return Promise.reject();
    }
  );
};
